import { RequestService } from '../../../../../common/services/RequestService';
import { GET_REQUEST } from '../../../Request/api/constants';
import { adjustDataResponse } from './adjustData';

export const getCurrentRequest = async payload => {
  const response = await RequestService.get(GET_REQUEST + payload.requestId);
  return {
    data: adjustDataResponse(response.data),
  };
};
